export const menuRouteEnum = Object.freeze({
  HOME: 'menu.home',
  LOGIN: 'menu.login',
  ACCOUNTING_BUDGET_DOCUMENTS: 'menu.accounting.budget_documents',
  ACCOUNTING_COST_REPORTS: 'menu.accounting.cost_reports',
  ACCOUNTING_INVOICES: 'menu.accounting.invoices',
  ACCOUNTING_REPORTS: 'menu.accounting.reports',
  ACCOUNTING_EXPENSE_CLAIMS: 'menu.accounting.expense_claims',
  COMPANY: 'menu.company',
  PROJECTS: 'menu.projects',
  RESOURCES: 'menu.resources',
  EQUIPMENTS: 'menu.equipments',
  TIMELINE: 'menu.timeline',
  STAFFS: 'menu.staffs',
  STAFF_MOVEMENTS: 'menu.staff.movements',
  COMPANIES: 'menu.companies',
  ROI_COMPARISON: 'menu.roi_comparison',
  GROUPS: 'menu.groups',
  LISTINGS: 'menu.listings',
  WAREHOUSE: 'menu.warehouses',
  WAREHOUSE_LIST: 'menu.warehouses.movements',
  WAREHOUSE_STOCK: 'menu.warehouses.availability',
  WAREHOUSE_PIVOT: 'menu.warehouses.pivot',
  NOTIFICATIONS: 'menu.notifications',
  EVENT_SCHEDULER: 'menu.event.scheduler',
  ABOUT: 'menu.about',
})

export const menuRoutes = Object.freeze({
  'menu.home': '/',
  'menu.login': '/login',
  'menu.company': '/company',
  'menu.accounting.budget_documents': '/accounting/budget-documents',
  'menu.accounting.cost_reports': '/accounting/cost-reports',
  'menu.accounting.invoices': '/accounting/invoices',
  'menu.accounting.reports': '/accounting/reports',
  'menu.accounting.expense_claims': '/accounting/expense-claims',
  'menu.projects': '/projects',
  'menu.equipments': '/equipments',
  'menu.timeline': '/timeline',
  'menu.staffs': '/staffs',
  'menu.staff.movements': '/staff/movements',
  'menu.companies': '/companies',
  'menu.roi_comparison': '/roi-comparison',
  'menu.groups': '/groups',
  'menu.listings': '/listings',
  'menu.warehouses.movements': '/warehouse/movements',
  'menu.warehouses.availability': '/warehouse/availability',
  'menu.warehouses.pivot': '/warehouse/pivot',
  'menu.notifications': '/notifications',
  'menu.event.scheduler': '/events-scheduler',
  'menu.about': '/about',
})
